export interface AmbientLandmark {
  id: string;
  viewBox: string;
  svg: string;
}

const A = (id: string, viewBox: string, svg: string): AmbientLandmark => ({
  id,
  viewBox,
  svg,
});

export const TEAM_AMBIENT_LANDMARK_IDS: Record<string, string> = {
  CZE: 'prague',
  KOR: 'pagoda',
  MEX: 'aztec',
  RSA: 'drakens',
  BIH: 'dalmatian',
  CAN: 'cnTower',
  QAT: 'minaret',
  SUI: 'chalet',
  BRA: 'rio',
  HAI: 'island',
  MAR: 'atlas',
  SCO: 'highland',
  AUS: 'opera',
  PAR: 'river',
  TUR: 'minaret',
  USA: 'liberty',
  CIV: 'baobab',
  CUW: 'island',
  ECU: 'andes',
  GER: 'brandenburg',
  JPN: 'fuji',
  NED: 'windmill',
  SWE: 'fjord',
  TUN: 'casbah',
  BEL: 'city',
  EGY: 'desert',
  IRN: 'persepolis',
  NZL: 'alps',
  CPV: 'island',
  ESP: 'sagrada',
  KSA: 'minaret',
  URU: 'ridge',
  FRA: 'eiffel',
  IRQ: 'minaret',
  NOR: 'fjord',
  SEN: 'savanna',
  ALG: 'casbah',
  ARG: 'tango',
  AUT: 'alps',
  JOR: 'petra',
  COD: 'savanna',
  COL: 'hills',
  POR: 'caravel',
  UZB: 'samarkand',
  CRO: 'dalmatian',
  ENG: 'bigBen',
  GHA: 'hills',
  PAN: 'canal',
};

export const TEAM_THEME_FLAVORS: Record<string, string> = {
  CZE: 'bohemian',
  KOR: 'zen',
  MEX: 'aztec',
  RSA: 'bold',
  BIH: 'none',
  CAN: 'crisp',
  QAT: 'baroque',
  SUI: 'precise',
  BRA: 'samba',
  HAI: 'tropical',
  MAR: 'zellige',
  SCO: 'tartan',
  AUS: 'open',
  PAR: 'lace',
  TUR: 'baroque',
  USA: 'varsity',
  CIV: 'bold',
  CUW: 'tropical',
  ECU: 'equator',
  GER: 'bauhaus',
  JPN: 'minimalist',
  NED: 'clean',
  SWE: 'nordic',
  TUN: 'mosaic',
  BEL: 'none',
  EGY: 'pharaonic',
  IRN: 'persian',
  NZL: 'none',
  CPV: 'tropical',
  ESP: 'matador',
  KSA: 'ornate',
  URU: 'none',
  FRA: 'parisian',
  IRQ: 'ornate',
  NOR: 'nordic',
  SEN: 'teranga',
  ALG: 'mosaic',
  ARG: 'tango',
  AUT: 'baroque',
  JOR: 'stonecut',
  COD: 'bold',
  COL: 'cafetero',
  POR: 'azulejo',
  UZB: 'silkroad',
  CRO: 'checker',
  ENG: 'heritage',
  GHA: 'kente',
  PAN: 'none',
};

export const AMBIENT_LANDMARKS: Record<string, AmbientLandmark> = {
  andes: A(
    'andes',
    '0 0 1200 600',
    '<path d="M0,600 L0,420 L140,280 L250,380 L360,220 L500,360 L640,180 L780,340 L900,240 L1050,400 L1200,300 L1200,600 Z" fill="currentColor"/><path d="M200,410 L260,360 L320,410 Z" fill="currentColor" opacity=".85"/><circle cx="980" cy="100" r="50" fill="currentColor" opacity=".55"/>',
  ),
  alps: A(
    'alps',
    '0 0 1200 600',
    '<path d="M0,600 L0,440 L160,300 L240,380 L340,240 L460,340 L580,200 L700,320 L820,220 L940,360 L1060,260 L1200,340 L1200,600 Z" fill="currentColor"/><path d="M420,340 L460,310 L500,340 L540,290 L580,340" stroke="currentColor" stroke-width="3" fill="none" opacity=".6"/>',
  ),
  atlas: A(
    'atlas',
    '0 0 1200 600',
    '<path d="M0,600 L0,400 L180,280 L340,380 L500,240 L660,360 L820,280 L1000,400 L1200,320 L1200,600 Z" fill="currentColor"/><g transform="translate(900,440)"><rect x="-40" y="0" width="80" height="100" fill="currentColor" opacity=".75"/><path d="M-40,0 L40,0 L20,-30 L-20,-30 Z" fill="currentColor" opacity=".75"/></g><circle cx="260" cy="120" r="55" fill="currentColor" opacity=".4"/>',
  ),
  aztec: A(
    'aztec',
    '0 0 1200 600',
    '<polygon points="400,540 520,460 680,460 800,540" fill="currentColor"/><polygon points="460,460 540,380 660,380 740,460" fill="currentColor" opacity=".85"/><polygon points="510,380 560,320 640,320 690,380" fill="currentColor"/><rect x="575" y="320" width="50" height="40" fill="currentColor" opacity=".65"/><circle cx="1020" cy="140" r="55" fill="currentColor" opacity=".45"/>',
  ),
  baobab: A(
    'baobab',
    '0 0 1200 600',
    '<path d="M0,540 Q300,500 600,520 Q900,540 1200,500 L1200,600 L0,600 Z" fill="currentColor" opacity=".6"/><g transform="translate(400,320)"><rect x="-16" y="0" width="32" height="220" fill="currentColor"/><path d="M-70,-30 Q-50,-80 0,-50 Q50,-80 70,-30 Q60,10 0,0 Q-60,10 -70,-30 Z" fill="currentColor"/></g><g transform="translate(900,360) scale(.7)"><rect x="-16" y="0" width="32" height="220" fill="currentColor" opacity=".75"/><path d="M-70,-30 Q-50,-80 0,-50 Q50,-80 70,-30 Q60,10 0,0 Q-60,10 -70,-30 Z" fill="currentColor" opacity=".75"/></g><circle cx="250" cy="140" r="55" fill="currentColor" opacity=".4"/>',
  ),
  bigBen: A(
    'bigBen',
    '0 0 1200 600',
    '<rect x="560" y="260" width="48" height="280" fill="currentColor"/><rect x="552" y="240" width="64" height="30" fill="currentColor"/><polygon points="552,240 584,180 616,240" fill="currentColor"/><polygon points="568,180 584,140 600,180" fill="currentColor"/><rect x="380" y="380" width="150" height="160" fill="currentColor" opacity=".75"/><rect x="640" y="400" width="180" height="140" fill="currentColor" opacity=".65"/><rect x="850" y="420" width="120" height="120" fill="currentColor" opacity=".55"/>',
  ),
  brandenburg: A(
    'brandenburg',
    '0 0 1200 600',
    '<rect x="420" y="220" width="360" height="320" fill="currentColor" opacity=".85"/><rect x="430" y="200" width="340" height="25" fill="currentColor"/><path d="M460,540 L460,260 M510,540 L510,260 M560,540 L560,260 M640,540 L640,260 M690,540 L690,260 M740,540 L740,260" stroke="rgba(0,0,0,.55)" stroke-width="6" opacity=".6"/><rect x="580" y="170" width="40" height="30" fill="currentColor"/><circle cx="600" cy="155" r="15" fill="currentColor"/>',
  ),
  canal: A(
    'canal',
    '0 0 1200 600',
    '<path d="M0,540 L1200,540 L1200,600 L0,600 Z" fill="currentColor"/><rect x="100" y="300" width="200" height="240" fill="currentColor" opacity=".7"/><rect x="320" y="340" width="180" height="200" fill="currentColor" opacity=".55"/><rect x="900" y="300" width="200" height="240" fill="currentColor" opacity=".7"/><rect x="700" y="340" width="180" height="200" fill="currentColor" opacity=".55"/><path d="M500,500 L700,500 L680,540 L520,540 Z" fill="currentColor"/><rect x="560" y="460" width="80" height="40" fill="currentColor"/>',
  ),
  caravel: A(
    'caravel',
    '0 0 1200 600',
    '<path d="M0,460 Q300,440 600,460 Q900,480 1200,450 L1200,600 L0,600 Z" fill="currentColor" opacity=".6"/><g transform="translate(600,380)"><path d="M-120,60 L-80,100 L80,100 L120,60 Z" fill="currentColor"/><rect x="-4" y="-120" width="8" height="180" fill="currentColor"/><path d="M4,-110 Q90,-70 4,-30 Z" fill="currentColor" opacity=".85"/><path d="M-4,-90 Q-80,-50 -4,-20 Z" fill="currentColor" opacity=".85"/></g>',
  ),
  casbah: A(
    'casbah',
    '0 0 1200 600',
    '<rect x="100" y="420" width="130" height="120" fill="currentColor" opacity=".65"/><circle cx="165" cy="420" r="28" fill="currentColor" opacity=".65"/><rect x="240" y="380" width="130" height="160" fill="currentColor"/><circle cx="305" cy="380" r="32" fill="currentColor"/><rect x="500" y="380" width="150" height="160" fill="currentColor" opacity=".85"/><circle cx="575" cy="380" r="38" fill="currentColor" opacity=".85"/><rect x="780" y="380" width="130" height="160" fill="currentColor"/><circle cx="845" cy="380" r="32" fill="currentColor"/><rect x="1080" y="300" width="30" height="240" fill="currentColor"/><path d="M1080,300 L1095,260 L1110,300 Z" fill="currentColor"/>',
  ),
  chalet: A(
    'chalet',
    '0 0 1200 600',
    '<path d="M0,600 L0,380 L200,200 L400,340 L600,180 L800,320 L1000,220 L1200,340 L1200,600 Z" fill="currentColor"/><path d="M200,200 L230,180 L260,220 Z M600,180 L625,160 L650,200 Z M1000,220 L1020,205 L1040,235 Z" fill="rgba(0,0,0,.5)" opacity=".8"/>',
  ),
  city: A(
    'city',
    '0 0 1200 600',
    '<rect x="80" y="360" width="80" height="180" fill="currentColor" opacity=".55"/><rect x="170" y="300" width="100" height="240" fill="currentColor" opacity=".7"/><rect x="360" y="260" width="110" height="280" fill="currentColor" opacity=".85"/><rect x="580" y="300" width="110" height="240" fill="currentColor" opacity=".75"/><rect x="790" y="260" width="120" height="280" fill="currentColor"/><rect x="1030" y="300" width="90" height="240" fill="currentColor" opacity=".75"/>',
  ),
  cnTower: A(
    'cnTower',
    '0 0 1200 600',
    '<rect x="600" y="180" width="14" height="360" fill="currentColor"/><ellipse cx="607" cy="260" rx="42" ry="22" fill="currentColor"/><ellipse cx="607" cy="230" rx="26" ry="14" fill="currentColor"/><rect x="220" y="360" width="120" height="180" fill="currentColor" opacity=".6"/><rect x="360" y="320" width="140" height="220" fill="currentColor" opacity=".7"/><rect x="720" y="340" width="130" height="200" fill="currentColor" opacity=".65"/><rect x="870" y="390" width="110" height="150" fill="currentColor" opacity=".55"/>',
  ),
  dalmatian: A(
    'dalmatian',
    '0 0 1200 600',
    '<path d="M0,600 L0,430 Q300,380 600,420 Q900,450 1200,380 L1200,600 Z" fill="currentColor" opacity=".7"/><path d="M0,440 L1200,440" stroke="currentColor" stroke-width="2" opacity=".3"/><path d="M200,440 L260,350 L320,440 Z" fill="currentColor" opacity=".6"/><path d="M380,440 L460,300 L540,440 Z" fill="currentColor"/><path d="M840,440 L900,340 L960,440 Z" fill="currentColor" opacity=".7"/>',
  ),
  desert: A(
    'desert',
    '0 0 1200 600',
    '<path d="M0,600 L0,500 Q250,420 500,500 T1200,490 L1200,600 Z" fill="currentColor" opacity=".9"/><polygon points="750,540 900,340 1050,540" fill="currentColor"/><polygon points="860,540 990,380 1100,540" fill="currentColor" opacity=".8"/><polygon points="620,540 700,430 780,540" fill="currentColor" opacity=".7"/><circle cx="200" cy="140" r="50" fill="currentColor" opacity=".55"/>',
  ),
  drakens: A(
    'drakens',
    '0 0 1200 600',
    '<path d="M0,600 L0,500 L150,380 L270,420 L380,300 L500,360 L620,240 L760,320 L900,280 L1040,380 L1200,320 L1200,600 Z" fill="currentColor"/><circle cx="940" cy="160" r="48" fill="currentColor" opacity=".5"/><path d="M100,600 Q600,540 1100,600" stroke="currentColor" stroke-width="3" opacity=".4" fill="none"/>',
  ),
  eiffel: A(
    'eiffel',
    '0 0 1200 600',
    '<path d="M540,560 L560,380 L555,300 L548,230 L540,120 L560,60 L580,120 L592,230 L585,300 L580,380 L600,560 Z" fill="currentColor"/><path d="M500,560 L540,560 L560,380 L580,380 L600,560 L640,560" stroke="currentColor" stroke-width="3" fill="none" opacity=".6"/><path d="M0,560 L1200,560" stroke="currentColor" stroke-width="2" opacity=".3"/>',
  ),
  fjord: A(
    'fjord',
    '0 0 1200 600',
    '<path d="M0,600 L0,380 L120,240 L220,360 L340,200 L460,340 L580,220 L700,360 L820,240 L960,360 L1080,260 L1200,380 L1200,600 Z" fill="currentColor"/><path d="M0,540 L1200,540" stroke="currentColor" stroke-width="2" opacity=".3"/><path d="M0,540 L1200,540 L1200,600 L0,600 Z" fill="currentColor" opacity=".45"/>',
  ),
  fuji: A(
    'fuji',
    '0 0 1200 600',
    '<path d="M0,600 L0,540 L380,260 Q450,210 520,260 L900,540 L1200,540 L1200,600 Z" fill="currentColor"/><path d="M430,285 L470,260 L510,285 L495,310 L445,310 Z" fill="rgba(0,0,0,.55)" opacity=".9"/><circle cx="900" cy="120" r="70" fill="currentColor" opacity=".5"/>',
  ),
  highland: A(
    'highland',
    '0 0 1200 600',
    '<path d="M0,540 Q300,460 600,500 Q900,540 1200,480 L1200,600 L0,600 Z" fill="currentColor" opacity=".7"/><path d="M200,540 Q250,420 320,540 Z" fill="currentColor" opacity=".5"/><path d="M850,540 Q920,400 990,540 Z" fill="currentColor" opacity=".5"/><path d="M500,520 Q600,340 700,520 Z" fill="currentColor"/><rect x="580" y="440" width="6" height="80" fill="currentColor"/><path d="M586,440 L620,430 L620,450 L586,455 Z" fill="currentColor"/>',
  ),
  hills: A(
    'hills',
    '0 0 1200 600',
    '<path d="M0,600 L0,460 Q200,380 400,440 T800,430 Q1000,380 1200,460 L1200,600 Z" fill="currentColor" opacity=".8"/><path d="M150,460 Q200,380 250,460 Z M400,440 Q470,350 540,440 Z M800,430 Q880,340 950,430 Z" fill="currentColor" opacity=".6"/>',
  ),
  island: A(
    'island',
    '0 0 1200 600',
    '<path d="M100,500 Q200,460 340,500 Q400,520 420,540 L80,540 Z" fill="currentColor" opacity=".75"/><path d="M500,480 Q700,440 900,480 Q1000,500 1080,540 L460,540 Z" fill="currentColor"/><g transform="translate(720,440)"><rect x="-3" y="0" width="6" height="80" fill="currentColor"/><path d="M0,0 Q-60,-40 -80,0 Z M0,0 Q60,-40 80,0 Z M0,0 Q-30,-60 0,-70 Z M0,0 Q30,-60 60,-60 Z" fill="currentColor"/></g><path d="M0,560 Q600,540 1200,560" stroke="currentColor" stroke-width="2" opacity=".4" fill="none"/>',
  ),
  liberty: A(
    'liberty',
    '0 0 1200 600',
    '<rect x="200" y="380" width="90" height="160" fill="currentColor" opacity=".6"/><rect x="300" y="280" width="100" height="260" fill="currentColor" opacity=".7"/><rect x="410" y="220" width="90" height="320" fill="currentColor" opacity=".8"/><rect x="740" y="260" width="90" height="280" fill="currentColor" opacity=".7"/><rect x="950" y="300" width="90" height="240" fill="currentColor" opacity=".65"/><g transform="translate(640,240)"><rect x="-4" y="60" width="8" height="140" fill="currentColor"/><path d="M-12,50 L-4,-10 L4,-10 L12,50 Z" fill="currentColor"/><circle cx="0" cy="-20" r="12" fill="currentColor"/><path d="M-14,-20 L14,-20 L18,-34 L-18,-34 Z" fill="currentColor"/></g>',
  ),
  minaret: A(
    'minaret',
    '0 0 1200 600',
    '<rect x="300" y="360" width="600" height="180" fill="currentColor" opacity=".7"/><path d="M300,360 Q600,280 900,360 Z" fill="currentColor" opacity=".7"/><circle cx="600" cy="330" r="55" fill="currentColor" opacity=".8"/><rect x="150" y="300" width="40" height="240" fill="currentColor"/><path d="M150,300 L170,260 L190,300 Z" fill="currentColor"/><rect x="1010" y="300" width="40" height="240" fill="currentColor"/><path d="M1010,300 L1030,260 L1050,300 Z" fill="currentColor"/>',
  ),
  opera: A(
    'opera',
    '0 0 1200 600',
    '<path d="M300,540 L300,440 Q400,340 480,440 L480,540 Z" fill="currentColor"/><path d="M440,540 L440,420 Q540,320 620,420 L620,540 Z" fill="currentColor" opacity=".85"/><path d="M580,540 L580,400 Q680,300 760,400 L760,540 Z" fill="currentColor"/><path d="M720,540 L720,420 Q820,320 900,420 L900,540 Z" fill="currentColor" opacity=".85"/><path d="M0,540 Q600,560 1200,540" stroke="currentColor" stroke-width="2" opacity=".4" fill="none"/>',
  ),
  pagoda: A(
    'pagoda',
    '0 0 1200 600',
    '<g transform="translate(600,520)"><rect x="-40" y="-40" width="80" height="40" fill="currentColor"/><path d="M-60,-40 L60,-40 L50,-60 L-50,-60 Z" fill="currentColor" opacity=".85"/><rect x="-50" y="-100" width="100" height="40" fill="currentColor" opacity=".9"/><path d="M-70,-100 L70,-100 L55,-125 L-55,-125 Z" fill="currentColor"/><rect x="-60" y="-165" width="120" height="40" fill="currentColor" opacity=".9"/><path d="M-85,-165 L85,-165 L65,-200 L-65,-200 Z" fill="currentColor"/><rect x="-4" y="-250" width="8" height="50" fill="currentColor"/></g>',
  ),
  persepolis: A(
    'persepolis',
    '0 0 1200 600',
    '<rect x="300" y="400" width="600" height="140" fill="currentColor" opacity=".75"/><rect x="320" y="340" width="30" height="70" fill="currentColor"/><rect x="420" y="300" width="30" height="110" fill="currentColor"/><rect x="520" y="270" width="30" height="140" fill="currentColor"/><rect x="570" y="260" width="30" height="150" fill="currentColor"/><rect x="620" y="260" width="30" height="150" fill="currentColor"/><rect x="720" y="280" width="30" height="130" fill="currentColor"/><rect x="870" y="340" width="30" height="70" fill="currentColor"/>',
  ),
  petra: A(
    'petra',
    '0 0 1200 600',
    '<path d="M300,540 L300,380 Q350,220 450,220 Q550,220 600,320 L600,540 Z" fill="currentColor"/><rect x="440" y="360" width="60" height="180" fill="rgba(0,0,0,.55)" opacity=".8"/><rect x="450" y="280" width="40" height="30" fill="currentColor" opacity=".85"/><path d="M600,540 L600,380 L800,540 Z" fill="currentColor" opacity=".7"/><path d="M800,540 L800,430 L1050,540 Z" fill="currentColor" opacity=".5"/>',
  ),
  prague: A(
    'prague',
    '0 0 1200 600',
    '<rect x="200" y="420" width="800" height="120" fill="currentColor" opacity=".65"/><polygon points="380,420 420,360 460,420" fill="currentColor"/><polygon points="500,420 540,340 580,420" fill="currentColor"/><polygon points="620,420 660,320 700,420" fill="currentColor"/><polygon points="740,420 780,340 820,420" fill="currentColor"/><rect x="658" y="280" width="4" height="40" fill="currentColor"/>',
  ),
  ridge: A(
    'ridge',
    '0 0 1200 600',
    '<path d="M0,600 L0,460 L180,340 L360,420 L520,300 L700,400 L880,320 L1060,420 L1200,360 L1200,600 Z" fill="currentColor" opacity=".75"/><path d="M0,600 L0,500 L200,430 L400,480 L600,420 L820,490 L1020,450 L1200,500 L1200,600 Z" fill="currentColor" opacity=".55"/>',
  ),
  rio: A(
    'rio',
    '0 0 1200 600',
    '<path d="M0,540 Q120,500 260,540 Q380,470 500,520 Q600,480 720,540 Q850,460 1000,510 Q1100,480 1200,520 L1200,600 L0,600 Z" fill="currentColor" opacity=".85"/><path d="M560,540 L580,260 Q585,240 600,230 Q615,240 620,260 L640,540 Z" fill="currentColor"/><circle cx="600" cy="190" r="10" fill="currentColor"/><path d="M580,200 L620,200 L615,240 L585,240 Z" fill="currentColor"/><path d="M555,200 L645,200" stroke="currentColor" stroke-width="3"/>',
  ),
  river: A(
    'river',
    '0 0 1200 600',
    '<path d="M0,400 Q300,360 600,420 Q900,480 1200,440" stroke="currentColor" stroke-width="60" fill="none" opacity=".4"/><path d="M0,420 Q300,380 600,440 Q900,500 1200,460" stroke="currentColor" stroke-width="2" fill="none"/><path d="M0,540 Q600,520 1200,540 L1200,600 L0,600 Z" fill="currentColor" opacity=".5"/>',
  ),
  sagrada: A(
    'sagrada',
    '0 0 1200 600',
    '<path d="M460,540 L470,300 Q480,240 490,200 Q500,150 505,100 Q510,150 520,200 Q530,240 540,300 L550,540 Z" fill="currentColor"/><path d="M560,540 L570,280 Q580,220 585,170 Q590,120 595,80 Q600,120 605,170 Q610,220 620,280 L630,540 Z" fill="currentColor"/><path d="M640,540 L650,300 Q660,240 670,200 Q680,150 685,100 Q690,150 700,200 Q710,240 720,300 L730,540 Z" fill="currentColor"/><path d="M740,540 L750,320 Q760,260 770,220 Q780,170 785,130 Q790,170 800,220 Q810,260 820,320 L830,540 Z" fill="currentColor" opacity=".85"/>',
  ),
  samarkand: A(
    'samarkand',
    '0 0 1200 600',
    '<rect x="300" y="420" width="600" height="120" fill="currentColor" opacity=".7"/><path d="M400,420 Q450,300 500,420 Z" fill="currentColor"/><path d="M600,420 Q670,280 740,420 Z" fill="currentColor"/><path d="M820,420 Q870,320 920,420 Z" fill="currentColor" opacity=".85"/><rect x="230" y="340" width="30" height="200" fill="currentColor"/><rect x="940" y="340" width="30" height="200" fill="currentColor"/>',
  ),
  savanna: A(
    'savanna',
    '0 0 1200 600',
    '<path d="M0,600 L0,450 Q300,410 600,440 T1200,430 L1200,600 Z" fill="currentColor" opacity=".8"/><g transform="translate(200,360)"><rect x="-2" y="0" width="4" height="160" fill="currentColor"/><ellipse cx="0" cy="-15" rx="90" ry="22" fill="currentColor"/></g><g transform="translate(900,380)"><rect x="-2" y="0" width="4" height="140" fill="currentColor"/><ellipse cx="0" cy="-10" rx="70" ry="18" fill="currentColor"/></g><circle cx="600" cy="140" r="60" fill="currentColor" opacity=".55"/>',
  ),
  tango: A(
    'tango',
    '0 0 1200 600',
    '<rect x="0" y="420" width="180" height="120" fill="currentColor" opacity=".55"/><rect x="190" y="380" width="160" height="160" fill="currentColor" opacity=".65"/><rect x="360" y="400" width="140" height="140" fill="currentColor" opacity=".5"/><rect x="710" y="390" width="160" height="150" fill="currentColor" opacity=".6"/><rect x="880" y="420" width="180" height="120" fill="currentColor" opacity=".5"/><rect x="1070" y="400" width="130" height="140" fill="currentColor" opacity=".65"/><g transform="translate(540,240)"><ellipse cx="10" cy="-30" rx="14" ry="18" fill="currentColor"/><path d="M-10,-10 Q0,30 -30,80 L-20,120 L10,90 Q30,40 30,0 Q50,-20 80,-10 L90,-30 Q70,-60 40,-50 Q10,-50 -10,-10 Z" fill="currentColor"/><ellipse cx="90" cy="-50" rx="12" ry="16" fill="currentColor"/><path d="M80,-30 Q120,10 100,80 L110,120 L140,90 Q150,20 130,-30 Q110,-50 80,-30 Z" fill="currentColor" opacity=".85"/></g>',
  ),
  windmill: A(
    'windmill',
    '0 0 1200 600',
    '<path d="M0,540 L1200,540 L1200,600 L0,600 Z" fill="currentColor" opacity=".5"/><g transform="translate(600,360)"><polygon points="-40,180 -25,0 25,0 40,180" fill="currentColor"/><polygon points="-30,0 -20,-40 20,-40 30,0" fill="currentColor"/><g transform="rotate(20)"><rect x="-6" y="-140" width="12" height="280" fill="currentColor" opacity=".85"/><rect x="-140" y="-6" width="280" height="12" fill="currentColor" opacity=".85"/></g></g><g transform="translate(200,420) scale(.5)"><polygon points="-40,180 -25,0 25,0 40,180" fill="currentColor" opacity=".6"/></g>',
  ),
};

export function getAmbientLandmark(idOrCode: string | null | undefined): AmbientLandmark | null {
  if (!idOrCode) return null;
  const key = idOrCode.toUpperCase();
  const id = TEAM_AMBIENT_LANDMARK_IDS[key] ?? idOrCode;
  return AMBIENT_LANDMARKS[id] ?? null;
}
